<template>
  <div>
    <NuxtLayout>
      <NuxtLoadingIndicator />
      <VitePwaManifest />
      <NuxtPage />
      <div class="preloader-curtain" data-animate="preloader-curtain"></div>
    </NuxtLayout>
  </div>
</template>

<script setup>
import formkitConfig from './formkit.config.js'
import { useStore } from '@/store/index.js'

const { locale } = useI18n()

await useAsyncData(() => useStore().fetchDatoConfiguration())

watch(
  () => locale.value,
  // FormKit
  (formkitConfig.locale = locale.value),
  async () => {
    await useAsyncData(() => useStore().fetchDatoConfiguration())
  }
)

const { lenis } = useLenis()
provide('lenis', lenis)
</script>
